// Trading Type Enum
export enum TradingType {
  NO_TRADING = "noTrading",
  PROFESSIONAL_TRADING = "professionalTrading",
  RETAIL_NONCOMPLEX_TRADING = "retailNoncomplexTrading",
  RETAIL_TRADING = "retailTrading",
}

// Button Action Enum
export enum ButtonAction {
  BUY = "BUY",
  SELL = "SELL",
  EXCHANGE = "EXCHANGE",
  FILL_THE_TEST = "FILL_THE_TEST",
  CALL_TO_BROKER = "CALL_TO_BROKER",
  SUBSCRIPTION = "SUBSCRIPTION",
  DETAILS = "DETAILS",
  FILL_W8BEN_FORM = "FILL_W8BEN_FORM",
}

// Page Context Enum
export enum PageContext {
  PORTFOLIO = "portfolio",
  HOLDING_DETAILS = "holdingDetails",
  TRADING = "trading",
  SECURITY_DETAILS = "securityDetails",
}

// Button Variant Enum
export enum ButtonVariant {
  PRIMARY = "Primary",
  SUCCESS = "Success",
  RED = "Red",
  LIGHT_GRAY = "LightGray",
  DARK = "Dark",
  TRANSPARENT = "Transparent",
}

// Access Rights Enum
export enum AccessRights {
  VIEW = "VIEW",
  FULL = "FULL",
}

// Portfolio Type Enum
export enum PortfolioTypeCode {
  BROKERAGE = "BROK",
  CBL = "CBL",
}

// Juridical Code Enum
export enum JuridicalCode {
  PRIVATE_PERSON = "PE",
  COMPANY = "CO",
}
